import React, { useRef, useState } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import html2canvas from 'html2canvas';
import './OrganizationChart.scss';

const orgData = {
  mayor: {
    title: 'T.C. İskenderun Belediye Başkanı',
    name: 'MEHMET DÖNMEZ',
    image: '/assets/images/mayor.jpg', // veya placeholder eklenecekse burası kullanılır
  },
  branches: [
    {
      role: 'Başkan Yardımcısı',
      name: 'Cihan AKYÜREKOĞLU',
      image: '/assets/images/cihan-akyurekoglu.png',
      departments: [
        "Basın Yayın ve Halkla İlişkiler Müdürlüğü",
        "Bilgi İşlem Müdürlüğü",
        "İşletme ve İştirakler Müdürlüğü",
        "İmar ve Şehircilik Müdürlüğü",
        "Emlak İstimlak Müdürlüğü",
        "Muhtarlıklar Müdürlüğü",
        "Gençlik ve Spor Hizmetleri Müdürlüğü",
        "İklim Değişikliği ve Sıfır Atık Müdürlüğü",
        "Veteriner İşleri Müdürlüğü",
        "Yapı Kontrol Müdürlüğü",
        "Kentsel Dönüşüm Müdürlüğü",
        "Ruhsat ve Denetim Müdürlüğü"
      ]
    },
    {
      role: 'Başkan Yardımcısı',
      name: 'Bülent TEMEL',
      image: '/assets/images/bulent-temel.jpg',
      departments: [
        "Makine İkmal Bakım ve Onarım Müdürlüğü",
        "Temizlik İşleri Müdürlüğü",
        "Fen İşleri Müdürlüğü",
        "Mali Hizmetler Müdürlüğü",
        "Hukuk İşleri Müdürlüğü",
        "Kültür ve Sosyal İşler Müdürlüğü",
        "Afet İşleri Müdürlüğü",
        "Park ve Bahçeler Müdürlüğü",
        "Destek Hizmetleri Müdürlüğü",
        "Zabıta Müdürlüğü",
        "İnsan Kaynakları ve Eğitim Müdürlüğü",
        "Gelirler Müdürlüğü",
        "Strateji Geliştirme Müdürlüğü"
      ]
    },
    {
      role: 'Başkan Yardımcısı',
      name: 'Nurullah ÇEKİRDEKÇİ',
      image: '/assets/images/nurullah-cekirdekci.png',
      departments: [
        "İskenderun Kent Hizmetleri A.Ş."
      ]
    },
    {
      role: 'Makama Bağlı Müdürlükler',
      name: null,
      image: null,
      departments: [
        "Özel Kalem Müdürlüğü",
        "Yazı İşleri Müdürlüğü",
        "Rehberlik ve Teftiş Kurulu Müdürlüğü"
      ]
    }
  ]
};

const OrganizationChart = () => {
  const treeRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadImage = async () => {
    if (!treeRef.current) return;
    setIsDownloading(true);
    
    try {
      // html2canvas ile yüksek çözünürlükte screenshot alıyoruz
      const canvas = await html2canvas(treeRef.current, {
        scale: 2, 
        backgroundColor: '#ffffff',
        useCORS: true // dışarıdan gelen imajlar için önemli
      });
      
      const image = canvas.toDataURL("image/png", 1.0);
      
      const link = document.createElement('a');
      link.download = 'Iskenderun_Belediyesi_Organizasyonu.png';
      link.href = image;
      link.click();
    } catch (err) {
      console.error('Ekran Görüntüsü alınırken hata oluştu:', err);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="organization-chart-page mt-5">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-lg-10 col-md-7">
            <div className="organization-chart-content">
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '10px' }}>
                <h1 className="page-title m-0">Organizasyon Şeması</h1>
                <button 
                  className="btn" 
                  style={{ backgroundColor: '#004b93', color: '#fff', borderRadius: '8px', padding: '8px 20px', fontWeight: 'bold' }} 
                  onClick={handleDownloadImage}
                  disabled={isDownloading}
                >
                  {isDownloading ? 'Hazırlanıyor...' : 'PNG Olarak İndir'}
                </button>
              </div>

              <div className="org-tree-wrapper" ref={treeRef} style={{ background: '#fff', padding: '20px' }}>
                <div className="tree">
                  {/* Level 1: Mayor */}
                  <ul>
                    <li>
                      <div className="org-card card-mayor">
                        {orgData.mayor.image && (
                          <div className="card-img-wrapper">
                            <img src={orgData.mayor.image} alt={orgData.mayor.name} onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                            <div className="img-placeholder" style={{ display: 'none' }}>{orgData.mayor.name.charAt(0)}</div>
                          </div>
                        )}
                        <div className="card-name">{orgData.mayor.name}</div>
                        <div className="card-title">{orgData.mayor.title}</div>
                      </div>

                      {/* Level 2: Branches */}
                      <ul>
                        {orgData.branches.map((branch, index) => (
                          <li key={index}>
                            <div className="org-card card-vice">
                              {branch.name ? (
                                <>
                                  {branch.image && (
                                    <div className="card-img-wrapper">
                                      <img src={branch.image} alt={branch.name} onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                                      <div className="img-placeholder" style={{ display: 'none' }}>{branch.name.charAt(0)}</div>
                                    </div>
                                  )}
                                  <div className="card-name">{branch.name}</div>
                                  <div className="card-title">{branch.role}</div>
                                </>
                              ) : (
                                <div
                                  className="card-title"
                                  style={{
                                    fontSize: '15px',
                                    fontWeight: 'bold',
                                    color: '#ff9f1c',
                                    margin: '0',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    width: '100%'
                                  }}
                                >
                                  {branch.role}
                                </div>
                              )}
                            </div>

                            {/* Level 3: Departments (Vertical Stack) */}
                            {branch.departments && branch.departments.length > 0 && (
                              <ul className="vertical-departments">
                                {branch.departments.map((dept, deptIdx) => (
                                  <li key={deptIdx}>
                                    <div className="dept-card">{dept}</div>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationChart;
